import VueRouter from 'vue-router';
import Login from "../views/Login.vue";
import ResetPassword from "../views/ResetPassword.vue";
import NotFound from "../views/errors/NotFound.vue";


const routes = [
    {
        path: '/admin/auth',
        name: 'login',
        component: Login,
    },
    {
        path: '/admin/auth/reset-password',
        name: 'reset-password',
        component: ResetPassword,
    },

    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    }
];

const router = new VueRouter({
    mode: 'history', // or 'hash'
    routes,
});

export default router;


